import { render, staticRenderFns } from "./globalConfig.vue?vue&type=template&id=1c7f3295&scoped=true&"
import script from "./globalConfig.vue?vue&type=script&lang=js&"
export * from "./globalConfig.vue?vue&type=script&lang=js&"
import style0 from "./globalConfig.vue?vue&type=style&index=0&id=1c7f3295&prod&lang=scss&scoped=true&"
import style1 from "./globalConfig.vue?vue&type=style&index=1&id=1c7f3295&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f3295",
  null
  
)

export default component.exports